export default class Cababilities {

  constructor() {
    this.bgTarget = '.our-capabilities';
    $('[data-cap-target]').hover((e) => {

      $('.our-capabilities__background').removeClass('active');

      $('#'+$(e.currentTarget).data('cap-target')).addClass('active');

      $('#'+$(e.currentTarget).data('cap-target')).trigger('load_lazy_image');
    });
  }

}



// WEBPACK FOOTER //
// ./scripts/blocks/our-cababilities.js